import { createAsyncThunk } from "@reduxjs/toolkit";
import { AccountApi, Configuration } from "api";
import { getBasePath } from "common/getConfiguration";
import { createErrorObject } from "errors/createErrorObject";
import { ErrorObject } from "errors/errorObject";
import { closeSnackbar, openSnackbar } from "features/ui";
import { getTranslationID } from "translation";
import type { RootState } from "app/store";

export const resetRequestAsync = createAsyncThunk<
  {
    /* Empty Object */
  },
  void,
  {
    state: RootState;
    // rejectした時の返却値の型
    rejectValue: {
      error: ErrorObject;
    };
  }
>("reset/resetRequestAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();
  const config = new Configuration({ basePath });

  const { email } = thunkApi.getState().reset.apps;

  try {
    thunkApi.dispatch(closeSnackbar());
    const accountApi = new AccountApi(config);
    const { data } = await accountApi.resetRequest({ email });
    return data;
  } catch (e) {
    const error = createErrorObject(e);
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({ error });
  }
});

export const resetExcuteAsync = createAsyncThunk<
  { success: boolean },
  void,
  {
    state: RootState;
    // rejectした時の返却値の型
    rejectValue: {
      error: ErrorObject;
    };
  }
>("reset/resetExcuteAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const config = new Configuration({ basePath });
  const { email, code, password } = thunkApi.getState().reset.apps;
  try {
    thunkApi.dispatch(closeSnackbar());
    // リセット実行API
    const accountApi = new AccountApi(config);
    await accountApi.reset({ code, email, password });
    return { success: true };
  } catch (e) {
    const error = createErrorObject(e);
    // Cognito NG
    if (error.errorCode === "E000202") {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID("resetPage.message.authcodeError"),
        })
      );
      return thunkApi.rejectWithValue({ error });
    }
    // Cognito Error
    if (error.errorCode === "E000204") {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID(
            "resetPage.message.requireRetryErrorOnPasswordReset"
          ),
        })
      );
      return thunkApi.rejectWithValue({ error });
    }
    // Sentinel NG
    if (error.errorCode === "E000104") {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID(
            "resetPage.message.requireRetryErrorOnPasswordReset"
          ),
        })
      );
      return thunkApi.rejectWithValue({ error });
    }

    // Cognito試行回数上限超え
    if (error.errorCode === "E000205") {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID("resetPage.message.tooManyFailedError"),
        })
      );
      return thunkApi.rejectWithValue({ error });
    }

    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({ error });
  }
});
